import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { useParams } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn } from "nsitools-react";
import { SearchTablePage } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import { ClubBreedApi, ClubBreedSearch, ClubGridDto } from "../../../../api";
import { Link } from "react-router-dom";
import { generateAddress } from "../../../../utils";

export interface IBreedClubPageProps {}

export const BreedClubPage: React.FunctionComponent<IBreedClubPageProps> = (props) => {
  const api = useApiService(ClubBreedApi);
  const { t } = useTl();
  const { id } = useParams<{ id: string }>();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: ClubGridDto) => (
          <Link target="_blank" to={`${ERoutes.club}/${row.clubId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.VATNumber),
        fieldName: "vatNumber",
      },
      {
        header: () => t(ETLCodes.Language),
        fieldName: "language",
      },
      {
        header: () => t(ETLCodes.MailAddress),
        fieldName: "address",
        render: (row: ClubGridDto) => generateAddress(row.number, row.street, row.city, row.postalCode, row.country),
      },
    ],
    [t]
  );

  // const selectItemFunction = React.useCallback(() => {
  //   history.push(`${ERoutes.color}/0/detail/edit`);
  // }, [history]);
  const search = React.useCallback(
    (sObj) => api.baseSearch(ClubBreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, breedId: +id })),
    [api, currentLanguage.languageId, id]
  );
  return (
    <SearchTablePage
      columns={columns}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(ClubBreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, breedId: +id }))
      }
      // addFunc={selectItemFunction}
      sortKeys={{ name: "ASC" }}
      withCard={false}
      breadCrumbs={[{ text: t(ETLCodes.Clubs) }]}
      // rightElement={
      //   <EditButton
      //     onClick={() => history.push(`${ERoutes.breeds}/${id}/clubs/selector`)}
      //     intent={Intent.PRIMARY}
      //     text={t(ETLCodes.Modify)}
      //   />
      // }
    />
  );
};
